import { createAction } from 'redux-actions';
import { SET_FILTERS_FROM_QUERY_PARAMS, SET_QUERY_PARAMS_FROM_FILTERS, RESET_FILTERS_QUERY_PARAMS } from './types';

export const setFiltersFromQueryParams = createAction(SET_FILTERS_FROM_QUERY_PARAMS);
export const setQueryParamsFromFilters = createAction(SET_QUERY_PARAMS_FROM_FILTERS);
export const resetFiltersFromQueryParams = createAction(RESET_FILTERS_QUERY_PARAMS);
